import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  condition: {
    searchText: '',
    limit: 100,
    page: 1
  },
  churchList: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
